<template>
    <section>
        <header class="page-header">
            <div class="page-header-top">
                <div class="page-header-nav">
                    <router-link :to="protocolListRoute" class="header-nav-link">
                        <span aria-hidden="true">←</span>
                        <span class="nav-label-full">Zurück zur Protokolliste</span>
                        <span class="nav-label-short">Zur Liste</span>
                    </router-link>
                    <router-link :to="newProtocolRoute" class="header-nav-link header-nav-link-right">
                        <span class="nav-label-full">Neues Protokoll erfassen</span>
                        <span class="nav-label-short">Neues Protokoll</span>
                        <span aria-hidden="true">→</span>
                    </router-link>
                </div>
                <h2>Protokoll</h2>
            </div>
            <div class="btn-wrapper" v-if="isInBearbeitung">
                <template v-if="isNativePicker">
                    <button type="button" class="btn btn-info btn-action" @click="pickFromGallery">
                        Galerie
                        <font-awesome-icon class="btn-icons" icon="fa-camera" />
                    </button>
                    <button type="button" class="btn btn-info btn-action" @click="pickFromCamera">
                        Kamera
                    </button>
                </template>
                <label v-else for="uploadmyfile" class="btn btn-info btn-action">
                    Bilder hochladen
                    <font-awesome-icon class="btn-icons" icon="fa-camera" />
                    <input
                        name="images"
                        type="file"
                        class="file-input-hidden"
                        id="uploadmyfile"
                        ref="fileInput"
                        multiple="multiple"
                        @change="requestUploadFile"
                        accept="image/*"
                    />
                </label>
                <button
                    v-if="pendingUploadFiles.length"
                    type="button"
                    class="btn btn-warning btn-action"
                    @click="retryPendingUploads"
                >
                    Fehlende Bilder erneut senden
                </button>
                <button @click="saveReport" class="btn btn-primary btn-action" type="button" style="color:white">
                    Änderungen speichern
                </button>
                <button @click="setReportStatusDone" type="button" class="btn btn-success btn-action">
                    Protokoll abschließen
                </button>
                <button
                    v-if="showPdfExport"
                    @click="generatePDF1(protokolId)"
                    type="button"
                    class="btn btn-outline-secondary btn-action downloadBtn"
                    title="PDF herunterladen"
                >
                    <font-awesome-icon icon="fa-file-pdf" />
                    <span class="download-label">PDF herunterladen</span>
                </button>
            </div>
            <div class="btn-wrapper" v-else-if="showPdfExport">
                <button
                    @click="generatePDF1(protokolId)"
                    type="button"
                    class="btn btn-outline-secondary btn-action downloadBtn"
                    title="PDF herunterladen"
                >
                    <font-awesome-icon icon="fa-file-pdf" />
                    <span class="download-label">PDF herunterladen</span>
                </button>
                <label class="enddate-option">
                    <input type="checkbox" v-model="displayEndDate" />
                    <span>Enddatum im PDF anzeigen</span>
                </label>
            </div>
        </header>

        <div id="pdf-doc">
            <!-- <div v-if="protokolImages.length != 0">length more then 0</div> -->
            <div v-for="(list, index) in protokolImages" :key="index">
                <div class="container">
                    <header v-if="index === 0" class="protocol-meta">
                        <p class="meta-objekt">
                            <label for="objektType">Objekt:</label>
                            <span v-if="!isInBearbeitung" class="meta-date-value">{{ protokolObject }}</span>
                            <span v-else class="meta-field">
                                <input type="text" :value="protokolObject" @input="
                                    (event) =>
                                    (protokolObject =
                                        event.target.value)
                                " class="input-update" name="objektType" />
                            </span>
                        </p>
                        <p
                            v-if="this.$store.state.auth.user.role != 'administrator'"
                            class="meta-datum"
                        >
                            <label>Datum:</label>
                            <span class="meta-date-value">{{ protokolDateOnly }}</span>
                        </p>
                        <p v-else-if="displayEndDate" class="meta-datum">
                            <label for="dateStart">Datum:</label>
                            <span v-if="!isInBearbeitung" class="meta-date-value">{{ formatDateTimeDisplay(protokolDate) }}</span>
                            <span v-else class="meta-field">
                                <input
                                    type="datetime-local"
                                    name="dateStart"
                                    @change="handleStartDateChange"
                                    v-model="protokolDate"
                                />
                            </span>
                        </p>
                        <p v-else class="meta-datum">
                            <label for="dateStart">Datum:</label>
                            <span v-if="!isInBearbeitung" class="meta-date-value">{{ protokolDateOnly }}</span>
                            <span v-else class="meta-field">
                                <input
                                    type="datetime-local"
                                    name="dateStart"
                                    @change="handleStartDateChange"
                                    v-model="protokolDate"
                                />
                            </span>
                        </p>
                        <p
                            v-if="
                                this.$store.state.auth.user.role ==
                                'administrator' && protokolDateEnd != '' && protokolDateEnd != undefined && displayEndDate
                            "
                            class="meta-ende"
                        >
                            <label for="dateEnd">Ende:</label>
                            <span v-if="!isInBearbeitung" class="meta-date-value">{{ formatDateTimeDisplay(protokolDateEnd) }}</span>
                            <span v-else class="meta-field">
                                <input
                                    type="datetime-local"
                                    name="dateEnd"
                                    @change="handleEndDateChange"
                                    v-model="protokolDateEnd"
                                />
                            </span>
                        </p>
                        <p class="meta-typ">
                            <label for="sonderreinigung" class="sonderreinigung-label">Protokolltyp:</label>
                            <span v-if="isBestandsaufnahme" class="meta-field">
                                <input
                                    type="text"
                                    id="protokol-type"
                                    name="protokol-type"
                                    :value="protokolType"
                                    disabled
                                />
                            </span>
                            <span v-else class="meta-field">
                                <select
                                    name="protokol-type"
                                    id="protokol-type"
                                    v-model="protokolType"
                                    @change="onSelectChange(e)"
                                    :disabled="!isInBearbeitung"
                                >
                                    <option value="Wöchentliche Reinigung">
                                        Wöchentliche Reinigung
                                    </option>
                                    <option value="Sonderreinigung">
                                        Sonderreinigung
                                    </option>
                                    <option value="Entrümpelung">
                                        Entrümpelung
                                    </option>
                                    <option value="Grünpflege">Grünpflege</option>
                                    <option value="Winterdienst">
                                        Winterdienst
                                    </option>
                                    <option value="Sonstige">Sonstiges</option>
                                </select>
                            </span>
                        </p>
                    </header>
                    <!-- <main v-bind:class="{ grid0: index === 0, gridRest: index > 0 }" @dragenter.prevent
                            @dragover.prevent v-if="protokolImages[0] !== ''"> -->
                    <!-- <main v-bind:class="{ grid0: index === 0, gridRest: index > 0 }" @dragenter.prevent @dragover.prevent
                        v-if="!noImagesToDisplay" :key="index">
                        <div class="imageWrapper" id="displayImageWrapper" ref="displayImageWrapper"
                            v-for="(image, index) in list" :key="index" draggable="true"
                            @dragstart="startDrag($event, index, list)" @drop="onDrop($event, index, list)">
                            <img :src="imageRoute(image)" @error="imageLoadError" class="img-fluid" :alt="image" />
                            <p class="display-delete-icon" v-if="isInBearbeitung" @click="deleteImage(list, index)">
                                <font-awesome-icon icon="fa-trash-can" />
                            </p>
                        </div>
                    </main> -->
                    <main v-bind:class="{ grid0: index === 0, gridRest: index > 0 }" @dragenter.prevent @dragover.prevent
                        v-if="!noImagesToDisplay" :key="index">
                        <div
                            class="imageWrapper"
                            :class="{
                                'imageWrapper--readonly': !isInBearbeitung,
                                'imageWrapper--loading': !imageRoute(image),
                                'imageWrapper--rotating': rotatingImages[image],
                            }"
                            id="displayImageWrapper"
                            ref="displayImageWrapper"
                            v-for="(image, imageIndex) in list"
                            :key="imageIndex"
                            :data-image-index="imageIndex"
                            :data-list-index="index"
                            :draggable="isInBearbeitung"
                            @dragstart="startDrag($event, imageIndex, list)"
                            @drop="onDrop($event, imageIndex, list)"
                            @touchstart="onTouchStart($event, imageIndex, index)"
                            @touchmove="onTouchMove"
                            @touchend="onTouchEnd"
                            @touchcancel="onTouchCancel"
                            @contextmenu="preventContextMenuIfEditing"
                        >
                            <img
                                v-if="imageRoute(image)"
                                :src="imageRoute(image)"
                                @error="imageLoadError"
                                class="img-fluid img-protocol"
                                :alt="image"
                                draggable="false"
                                @contextmenu="preventContextMenuIfEditing"
                            />
                            <p
                                class="display-rotate-icon"
                                v-if="isInBearbeitung"
                                title="Bild drehen"
                                @click.stop="rotateImage(image)"
                                @mousedown.stop
                                @touchstart.stop
                                @contextmenu.prevent
                            >
                                <font-awesome-icon icon="fa-rotate-right" />
                            </p>
                            <p
                                class="display-delete-icon"
                                v-if="isInBearbeitung"
                                @click="deleteImage(list, imageIndex)"
                                @touchstart.stop
                                @contextmenu.prevent
                            >
                                <font-awesome-icon icon="fa-trash-can" />
                            </p>
                            <textarea
                                v-if="isBestandsaufnahme && isInBearbeitung"
                                class="image-caption-input"
                                rows="2"
                                maxlength="500"
                                placeholder="Beschreibung…"
                                :value="imageCaptions[image] || ''"
                                @input="setImageCaption(image, $event.target.value)"
                                @mousedown.stop
                                @touchstart.stop
                                @dragstart.stop
                            />
                            <p
                                v-else-if="isBestandsaufnahme && imageCaptions[image]"
                                class="image-caption-text"
                            >
                                {{ imageCaptions[image] }}
                            </p>
                        </div>
                    </main>
                    <main v-else>
                        <h4 class="no-images-message">Es sind noch keine Bilder hochgeladen worden</h4>
                    </main>
                </div>
            </div>
        </div>
        <!-- <modal-loader-window :displayModalLodaer="showModalLoader">
            <template #header>
                <span v-html="modalMessageHeader"></span>
            </template>
        </modal-loader-window> -->
        <modal-loader-window :displayModalLodaer="showModalLoader" :timeout="3000" @close="closeModalLoader">
            <template #header>
                <h2 class="loader-title">{{ loaderMessage }}</h2>
            </template>
        </modal-loader-window>
        <modal-message-window :displayModalMessage="showModalMessage">
            <template #header>
                <span v-html="modalMessageHeader"></span>
                <!-- {{ modalMessageHeader }} -->
            </template>
            <template #body>
                <span v-html="modalMessageBody"></span>
                <!-- {{ modalMessageBody }} -->
            </template>
        </modal-message-window>

    </section>
</template>

<script>
import axios from 'axios';
import { ref } from 'vue';
import ModalLoaderWindow from '../static_elements/ModalLoaderWindow.vue';
import ModalMessageWindow from '../static_elements/ModalMessageWindow.vue';
import API_BACKEND_URL from '@/API_URL/api_back_end.js';
import { compressImagesForUpload } from '@/utils/compressImageForUpload.js';
import {
    clearFileInput,
    filesFromFileInput,
    pickImages,
    takeCameraPhoto,
    PICK_IMAGES_MAX_FILES,
} from '@/utils/imagePicker.js';
import {
    appendImagesInChunks,
    ensureUploadId,
    messageForUploadError,
} from '@/utils/protocolUpload.js';

import { useToast } from 'vue-toastification';
import { isMobileBuild, isNativeApp } from '@/utils/platform';
import { formatLocalProtocolDateTime } from '@/utils/localDateTime.js';

// import { requireImage } from "./import_images.js"; // eslint-disable-line no-unused-vars

export default {
    components: { ModalLoaderWindow, ModalMessageWindow },

    data() {
        return {
            protokolId: this.$route.params.itemId,
            refreshed: false,
            protokolStatus: this.$route.params.status,
            displayEndDate: false,
            protokolDateOnly: '',
            protokolDate: '',
            protokolDateEnd: '',
            noImagesToDisplay: false,
            protokolImages: [],
            preview_list: [],
            protokolObject: '',
            protokolType: '',
            countOfImagesOnFirstPage: 6,
            countOfImagesForRestPages: 9,
            finalList: [],
            startDrop: '',
            endDrop: '',
            // Styling elements
            containerBorder: '',
            containerMargin: '',
            // gridSpilter before was empty
            gridSpilter: '35% 35% 35%',
            // For Div splittin
            firstPage: true,
            // Image counter on screen
            imageCounterOnScreen: 0,
            // For Drag and Drop
            tempVarImage: '',
            touchDrag: null,
            // Saving updated protokol
            formData: new FormData(),
            counter: 0,
            // For upload images
            uploadedImages: [],
            pendingUploadFiles: [],
            checkingImagesExistance: [],
            // Modal
            showModalLoader: false,
            showModalMessage: false,
            loaderMessage: 'Laden…',
            modalMessageHeader: '',
            modalMessageBody: '',
            // Toast
            toast: useToast(),

            imageCheckerResponse: 0,
            imageBlobUrls: {},
            imageCaptions: {},
            rotatingImages: {},
        };
    },
    computed: {
        isInBearbeitung() {
            return this.protokolStatus === 'In Bearbeitung' || this.protokolStatus === 'In bearbeitung';
        },
        isBestandsaufnahme() {
            return this.protokolType === 'Bestandsaufnahme';
        },
        isNativePicker() {
            return isNativeApp();
        },
        protocolListRoute() {
            const from = this.$route.query.from;
            const listType =
                typeof from === 'string' && from.trim()
                    ? from
                    : this.isInBearbeitung
                        ? 'In Bearbeitung'
                        : 'Abgeschlossen';
            const { listQ, listPage } = this.$route.query;
            const query = {};
            if (typeof listQ === 'string' && listQ) {
                query.q = listQ;
            }
            if (typeof listPage === 'string' && listPage) {
                query.page = listPage;
            }
            return {
                name: 'prtokollist',
                params: { listType },
                query,
            };
        },
        newProtocolRoute() {
            return { name: 'protokolerfassen' };
        },
        showPdfExport() {
            return !isMobileBuild();
        },
    },
    created() {
        this.imageBlobAbort = null;
        this.imageBlobUnmounted = false;
        this.imageBlobLoading = null;
        if (this.protokolStatus === 'In bearbeitung') {
            this.protokolStatus = 'In Bearbeitung';
        }
    },
    methods: {
        async fetchItem(id) {
            this.loaderMessage = 'Protokoll laden…';
            this.showModalLoader = true;
            try {
                const response = await axios.get(`${API_BACKEND_URL}list_display/protokol/${id}`);
                //mg bug fix date in protokll anschauen (which i made :D)
                // fix undefi undefined
                if ((response.data[0].dateTimeCreate).includes("undefi")) {
                    let tmp = response.data[0].dateTimeCreate;
                    tmp = tmp.substring(0, tmp.indexOf(' ', tmp.indexOf(' ') + 1));
                    response.data[0].dateTimeCreate = tmp;
                }

                if (response.data[0].dateTimeCreate.split(' ')[0].length !== 0) {
                    this.protokolDateOnly = response.data[0].dateTimeCreate.split(' ')[0];
                } else {
                    this.protokolDateOnly = response.data[0].dateTimeCreate.split('T')[0];
                }
                if (response.data[0].dateTimeCreate === undefined) {
                    this.protokolDate = response.data[0].date;
                } else {
                    if (response.data[0].dateTimeCreate.length > 16) {
                        this.protokolDate = response.data[0].dateTimeCreate.slice(0, -3);
                    } else {
                        this.protokolDate = response.data[0].dateTimeCreate;
                    }
                }
                if (response.data[0].dateTimeClosed === undefined) {
                    this.protokolDateEnd = response.data[0].date + 'T00:00';
                } else {
                    if (response.data[0].dateTimeClosed.length > 16) {
                        this.protokolDateEnd = response.data[0].dateTimeClosed.slice(0, -3);
                    } else {
                        this.protokolDateEnd = response.data[0].dateTimeClosed;
                    }
                }
                this.preview_list = response.data[0].images;
                this.protokolObject = response.data[0].objekt;
                this.protokolType = response.data[0].type;
                this.syncImageCaptions(
                    response.data[0].images,
                    response.data[0].imageCaptions,
                );

                if (response.data[0].images.length > 0 && response.data[0].images != 'null' && response.data[0].images[0] != '') {
                    // Raster sofort, Bilder progressiv — Loader nicht auf alle Blobs warten
                    this.protokolImages = this.listOfLists(
                        response.data[0].images,
                        this.countOfImagesOnFirstPage,
                        this.countOfImagesForRestPages,
                    );
                    this.noImagesToDisplay = false;
                    this.loadImageBlobs(response.data[0].images);
                } else {
                    this.noImagesToDisplay = true;
                    this.protokolImages = [''];
                }
            } catch (err) {
                console.log(err);
            } finally {
                this.closeModalLoader();
            }
        },
        findList(target) {
            let arr = this.protokolImages;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].toString() === target.toString()) {
                    return i;
                }
            }
        },
        preventContextMenuIfEditing(event) {
            if (this.isInBearbeitung) {
                event.preventDefault();
            }
        },
        startDrag(event, startIndex, list) {
            if (!this.isInBearbeitung) {
                event.preventDefault();
                return;
            }
            this.tempVarImage = [startIndex, this.findList(list)];
        },
        swapImages(fromList, fromIndex, toList, toIndex) {
            if (!this.isInBearbeitung) return;
            if (
                fromList == null ||
                toList == null ||
                fromIndex == null ||
                toIndex == null
            ) {
                return;
            }
            if (fromList === toList && fromIndex === toIndex) return;
            if (
                !this.protokolImages[fromList] ||
                !this.protokolImages[toList]
            ) {
                return;
            }
            const image = this.protokolImages[toList][toIndex];
            this.protokolImages[toList][toIndex] =
                this.protokolImages[fromList][fromIndex];
            this.protokolImages[fromList][fromIndex] = image;
            // Neue Referenzen, damit Vue die Grid-Seiten zuverlässig neu rendert
            this.protokolImages = this.protokolImages.map((page) => [...page]);
        },
        onDrop(event, targetIndex, list) {
            event.preventDefault();
            if (!this.isInBearbeitung || !this.tempVarImage) return;
            const startImageIndex = this.tempVarImage[0];
            const startImageList = this.tempVarImage[1];
            const listNumber = this.findList(list);
            this.swapImages(
                startImageList,
                startImageIndex,
                listNumber,
                targetIndex,
            );
            this.tempVarImage = '';
        },
        clearTouchDragStyles() {
            document
                .querySelectorAll('.imageWrapper.is-dragging, .imageWrapper.drop-target')
                .forEach((node) => {
                    node.classList.remove('is-dragging', 'drop-target');
                });
        },
        clearTouchDragTimer() {
            if (this.touchDrag && this.touchDrag.longPressTimer) {
                clearTimeout(this.touchDrag.longPressTimer);
                this.touchDrag.longPressTimer = null;
            }
        },
        onTouchStart(event, imageIndex, listIndex) {
            if (!this.isInBearbeitung) return;
            if (event.target.closest('.display-delete-icon, .display-rotate-icon')) return;
            const touch = event.touches[0];
            if (!touch) return;
            const sourceEl = event.currentTarget;
            this.touchDrag = {
                startIndex: imageIndex,
                listIndex,
                startX: touch.clientX,
                startY: touch.clientY,
                active: false,
                sourceEl,
                longPressTimer: setTimeout(() => {
                    if (!this.touchDrag || this.touchDrag.sourceEl !== sourceEl) {
                        return;
                    }
                    this.touchDrag.active = true;
                    this.touchDrag.sourceEl.classList.add('is-dragging');
                    if (navigator.vibrate) {
                        navigator.vibrate(12);
                    }
                }, 280),
            };
        },
        onTouchMove(event) {
            if (!this.touchDrag) return;
            const touch = event.touches[0];
            if (!touch) return;
            const dx = touch.clientX - this.touchDrag.startX;
            const dy = touch.clientY - this.touchDrag.startY;

            // Vor dem Long-Press: bei Bewegung als Scroll werten und abbrechen
            if (!this.touchDrag.active) {
                if (Math.abs(dx) + Math.abs(dy) > 10) {
                    this.clearTouchDragTimer();
                    this.touchDrag = null;
                }
                return;
            }

            event.preventDefault();
            this.clearTouchDragStyles();
            this.touchDrag.sourceEl.classList.add('is-dragging');
            const el = document.elementFromPoint(touch.clientX, touch.clientY);
            const wrapper = el && el.closest ? el.closest('.imageWrapper') : null;
            if (wrapper && wrapper !== this.touchDrag.sourceEl) {
                wrapper.classList.add('drop-target');
            }
        },
        onTouchEnd(event) {
            if (!this.touchDrag) return;
            this.clearTouchDragTimer();
            const drag = this.touchDrag;
            this.touchDrag = null;
            this.clearTouchDragStyles();
            if (!drag.active) return;
            const touch = event.changedTouches[0];
            if (!touch) return;
            const el = document.elementFromPoint(touch.clientX, touch.clientY);
            const wrapper = el && el.closest ? el.closest('.imageWrapper') : null;
            if (!wrapper || wrapper === drag.sourceEl) return;
            const targetIndex = Number(wrapper.dataset.imageIndex);
            const targetList = Number(wrapper.dataset.listIndex);
            if (Number.isNaN(targetIndex) || Number.isNaN(targetList)) return;
            this.swapImages(
                drag.listIndex,
                drag.startIndex,
                targetList,
                targetIndex,
            );
        },
        onTouchCancel() {
            this.clearTouchDragTimer();
            this.touchDrag = null;
            this.clearTouchDragStyles();
        },
        dragOver(event) {
            event.preventDefault();
        },
        // Handle the drop event
        drop(event) {
            event.preventDefault();
        },
        importAll(r) {
            return r.keys().map(r);
        },

        imageRoute(img) {
            if (!img) {
                return '';
            }
            return this.imageBlobUrls[img] || '';
        },
        isImageBlobRequestCanceled(err) {
            return (
                err?.code === 'ERR_CANCELED' ||
                err?.name === 'CanceledError' ||
                err?.name === 'AbortError'
            );
        },
        async ensureImageBlob(img, signal) {
            if (
                !img ||
                this.imageBlobUnmounted ||
                this.imageBlobUrls[img] ||
                this.imageBlobLoading?.[img]
            ) {
                return;
            }
            if (!this.imageBlobLoading) {
                this.imageBlobLoading = {};
            }
            this.imageBlobLoading[img] = true;
            try {
                const res = await axios.get(
                    `${API_BACKEND_URL}protokol/${encodeURIComponent(this.protokolId)}/images/${encodeURIComponent(img)}`,
                    { responseType: 'blob', signal },
                );
                if (this.imageBlobUnmounted || signal?.aborted) {
                    return;
                }
                this.imageBlobUrls = {
                    ...this.imageBlobUrls,
                    [img]: URL.createObjectURL(res.data),
                };
            } catch (err) {
                if (!this.isImageBlobRequestCanceled(err)) {
                    console.error('Bild konnte nicht geladen werden:', img, err);
                }
            } finally {
                if (this.imageBlobLoading) {
                    delete this.imageBlobLoading[img];
                }
            }
        },
        async loadImageBlobs(images) {
            if (this.imageBlobAbort) {
                this.imageBlobAbort.abort();
            }
            const controller = new AbortController();
            this.imageBlobAbort = controller;
            const names = (images || []).filter(Boolean);
            // Begrenzt parallel laden — sonst blockiert der Browser-Connection-Pool
            // den Listen-Request beim Zurücknavigieren.
            const concurrency = 4;
            let nextIndex = 0;
            const workers = Array.from(
                { length: Math.min(concurrency, names.length) },
                async () => {
                    while (nextIndex < names.length && !controller.signal.aborted) {
                        const img = names[nextIndex];
                        nextIndex += 1;
                        await this.ensureImageBlob(img, controller.signal);
                    }
                },
            );
            await Promise.all(workers);
        },
        abortImageBlobLoads() {
            if (this.imageBlobAbort) {
                this.imageBlobAbort.abort();
                this.imageBlobAbort = null;
            }
            this.imageBlobLoading = {};
        },
        revokeImageBlobs() {
            Object.values(this.imageBlobUrls).forEach((url) => {
                try {
                    URL.revokeObjectURL(url);
                } catch (err) {
                    // ignore
                }
            });
            this.imageBlobUrls = {};
        },
        diplayModal() {
            this.loaderMessage = 'Bilder hochladen…';
            this.showModalLoader = true;
        },

        closeModalLoader() {
            this.showModalLoader = false;
        },
        imageLoadError() {
            console.log('Image failed to load');
        }
        ,
        listOfLists(list, counOfImagesFor1stPage, counOfImagesFor2ndPage) {
            let replyList = [];
            let tempList = [];
            let counterToSplitInnerArrays = counOfImagesFor1stPage;
            if (list.length) {
                for (let i = 0; i < list.length; i++) {
                    if (i < counOfImagesFor1stPage - 1) {
                        tempList.push(list[i]);
                        if (i === list.length - 1) {
                            replyList.push(tempList);
                            tempList = [];
                        }
                    } else if (i === counOfImagesFor1stPage - 1) {
                        tempList.push(list[i]);
                        replyList.push(tempList);
                        tempList = [];
                    } else if (
                        i - counterToSplitInnerArrays <
                        counOfImagesFor2ndPage - 1
                    ) {
                        tempList.push(list[i]);
                        if (i === list.length - 1) {
                            replyList.push(tempList);
                            tempList = [];
                        }
                    } else {
                        tempList.push(list[i]);
                        replyList.push(tempList);
                        tempList = [];
                        counterToSplitInnerArrays =
                            counterToSplitInnerArrays + counOfImagesFor2ndPage;
                    }
                }
                if (replyList[0].length > 5) {
                    this.gridSpilter = '33% 33% 33%';
                }
                return replyList;
            }
        },
        generatePDF1(id) {
            this.modalMessageHeader = 'PDF report wird generiert (Kann bis zu einigen Minuten dauern)...';
            this.showModalMessage = true;
            let fileName = this.protokolDate.slice(0, -3) + '_' + this.protokolObject;
            // add startdate and end date
            // changes added by mg
            axios.get(`${API_BACKEND_URL}generate-pdf/${id}/${this.displayEndDate}/${this.protokolDate}/${this.protokolDateEnd}`, {
                responseType: 'blob' // Set the response type to 'blob'
            })
                .then((response) => {
                    console.log(response)
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${fileName}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    this.showModalMessage = false;
                    this.modalMessageHeader = '';
                }).catch((err) => {
                    console.log(err)
                    this.modalMessageHeader = '';
                    this.showModalMessage = false;
                })
        }
        ,
        async pickFromGallery() {
            try {
                const files = await pickImages({ input: this.$refs.fileInput });
                await this.ingestPickedFiles(files);
            } catch (err) {
                console.error(err);
                this.toast.error('Galerie konnte nicht geöffnet werden.', {
                    timeout: 2000,
                });
            }
        },
        async pickFromCamera() {
            try {
                const files = await takeCameraPhoto();
                await this.ingestPickedFiles(files);
            } catch (err) {
                console.error(err);
                this.toast.error('Kamera konnte nicht geöffnet werden.', {
                    timeout: 2000,
                });
            }
        },
        async requestUploadFile(event) {
            const files = filesFromFileInput(event.target);
            await this.ingestPickedFiles(files, event.target);
        },
        async ingestPickedFiles(files, input) {
            if (!files.length) {
                if (input) {
                    clearFileInput(input);
                }
                return;
            }
            // Samsung Internet feuert `change` am Datei-Input gelegentlich doppelt.
            if (this._ingestInFlight) {
                return;
            }
            this._ingestInFlight = true;
            this.diplayModal();
            this.previewImage = 1;
            this.file = files[0];
            try {
                const maxFiles = PICK_IMAGES_MAX_FILES;
                if (files.length > maxFiles) {
                    this.closeModalLoader();
                    this.toast.warning(
                        `Bitte maximal ${maxFiles} Bilder auf einmal auswählen.`,
                        {
                            timeout: 3000,
                        },
                    );
                    return;
                }
                const compressedFiles = await compressImagesForUpload(files);
                compressedFiles.forEach(ensureUploadId);
                await this.uploadImagesChunked(compressedFiles);
            } catch (err) {
                console.error(err);
                const detail = messageForUploadError(err);
                this.toast.error(
                    detail || 'Bilder konnten nicht hochgeladen werden.',
                    { timeout: 4000 },
                );
                this.closeModalLoader();
            } finally {
                this._ingestInFlight = false;
                if (input) {
                    clearFileInput(input);
                }
            }
        },
        async retryPendingUploads() {
            const files = this.pendingUploadFiles.slice();
            if (!files.length || this._ingestInFlight) {
                return;
            }
            this._ingestInFlight = true;
            this.diplayModal();
            try {
                await this.uploadImagesChunked(files);
            } catch (err) {
                console.error(err);
                this.toast.error('Bilder konnten nicht hochgeladen werden.', {
                    timeout: 4000,
                });
                this.closeModalLoader();
            } finally {
                this._ingestInFlight = false;
            }
        },
        async uploadImagesChunked(files) {
            this.loaderMessage = 'Bilder hochladen…';
            const result = await appendImagesInChunks({
                protocolId: this.protokolId,
                files,
                onProgress: (_done, _total, label) => {
                    this.loaderMessage = label;
                },
            });
            const sent = new Set(files);
            if (result.complete) {
                this.pendingUploadFiles = this.pendingUploadFiles.filter(
                    (file) => !sent.has(file),
                );
            } else {
                const untouched = this.pendingUploadFiles.filter(
                    (file) => !sent.has(file),
                );
                this.pendingUploadFiles = result.remainingFiles.concat(untouched);
            }
            if (result.protocol) {
                this.applyUpdatedRecord(
                    result.protocol,
                    result.complete ? 'images' : 'images-partial',
                );
            }
            if (!result.complete) {
                this.closeModalLoader();
                const arrived = result.uploadedFiles.length;
                const detail = messageForUploadError(result.error);
                const base = arrived
                    ? `${result.remainingFiles.length} Bild(er) nicht angekommen. „Fehlende Bilder erneut senden“ schickt dieselben Bilder noch einmal, ohne sie doppelt anzulegen.`
                    : 'Bilder konnten nicht hochgeladen werden.';
                const text = detail && arrived ? `${base} ${detail}` : detail || base;
                this.toast.warning(text, { timeout: 6000 });
                return;
            }
            if (!result.protocol) {
                this.closeModalLoader();
            }
        },
        applyUpdatedRecord(record, kind) {
            if (!record || !Array.isArray(record.images)) {
                this.closeModalLoader();
                return;
            }
            if (kind === 'save') {
                this.toast.success('Protokolländerungen gespeichert!', {
                    timeout: 2000,
                });
            } else if (kind === 'images') {
                this.toast.success('Bilder erfolgreich hochgeladen', {
                    timeout: 2000,
                });
            }
            this.noImagesToDisplay = false;
            this.protokolImages = this.listOfLists(
                record.images,
                this.countOfImagesOnFirstPage,
                this.countOfImagesForRestPages,
            );
            this.syncImageCaptions(record.images, record.imageCaptions);
            if (kind === 'save') {
                this.applyServerProtocolDates(record);
            }
            this.formData = new FormData();
            this.closeModalLoader();
            this.loadImageBlobs(record.images);
        },
        collectImageNames() {
            const pages = Array.isArray(this.protokolImages)
                ? this.protokolImages
                : [];
            return pages
                .flatMap((page) => (Array.isArray(page) ? page : [page]))
                .filter((name) => typeof name === 'string' && name && name !== 'null');
        },
        captionsObjectFromRecord(raw) {
            if (!raw) {
                return {};
            }
            if (typeof raw === 'object' && !Array.isArray(raw)) {
                // Mongoose Map → plain via entries, or already plain
                if (typeof raw.entries === 'function') {
                    return Object.fromEntries(raw.entries());
                }
                return { ...raw };
            }
            return {};
        },
        syncImageCaptions(imageNames, rawCaptions) {
            const names = Array.isArray(imageNames) ? imageNames : [];
            const fromDb = this.captionsObjectFromRecord(rawCaptions);
            const prev = this.imageCaptions || {};
            const next = {};
            for (const name of names) {
                if (typeof name !== 'string' || !name || name === 'null') {
                    continue;
                }
                if (prev[name] != null && prev[name] !== '') {
                    next[name] = prev[name];
                } else {
                    next[name] = fromDb[name] || '';
                }
            }
            this.imageCaptions = next;
        },
        setImageCaption(imageName, value) {
            this.imageCaptions = {
                ...this.imageCaptions,
                [imageName]: value,
            };
        },
        buildSaveFormData({ status, dtClose } = {}) {
            const fd = new FormData();
            const imageNames = this.collectImageNames();
            if (imageNames.length) {
                fd.append('imageList', JSON.stringify(imageNames));
            } else {
                fd.append('imageList', '[]');
                this.noImagesToDisplay = true;
            }
            if (this.isBestandsaufnahme) {
                const captions = {};
                for (const name of imageNames) {
                    const text = String(this.imageCaptions[name] || '').trim();
                    if (text) {
                        captions[name] = text;
                    }
                }
                fd.append('imageCaptions', JSON.stringify(captions));
            }

            fd.append('objekt', this.protokolObject);
            const dateValue = this.protokolDate || '';
            if (dateValue.includes('T')) {
                fd.append('date', dateValue.split('T')[0]);
                const [day, time] = dateValue.split('T');
                fd.append('dtCreate', time != null ? `${day} ${time}` : dateValue);
            } else if (dateValue.includes(' ')) {
                fd.append('date', dateValue.split(' ')[0]);
                const [day, time] = dateValue.split(' ');
                fd.append('dtCreate', time != null ? `${day} ${time}` : dateValue);
            } else {
                fd.append('date', dateValue);
                fd.append('dtCreate', dateValue);
            }
            fd.append('type', this.protokolType);
            fd.append('status', status || this.protokolStatus);
            if (dtClose != null) {
                fd.append('dtClose', dtClose);
            }
            fd.append('action', 'saveUpdate');
            return fd;
        },
        saveReport() {
            this.updateDbById(this.buildSaveFormData());
        },
        setReportStatusDone() {
            const dateAndTime = formatLocalProtocolDateTime(new Date());
            this.protokolDateEnd = dateAndTime;
            this.protokolStatus = 'Abgeschlossen';
            this.updateDbById(
                this.buildSaveFormData({
                    status: 'Abgeschlossen',
                    dtClose: dateAndTime,
                }),
            );
            // Change URL Param from 'In baerbeitung -> Abgeschlossen'
            const url = new URL(window.location.href);
            const pathParts = url.pathname.split('/');
            pathParts[pathParts.length - 1] = 'Abgeschlossen';
            url.pathname = pathParts.join('/');
            window.history.replaceState(window.history.state, '', url.href);
        },
        async updateDbById(fd) {
            if (this._updateInFlight) {
                return;
            }
            this._updateInFlight = true;
            try {
                // Content-Type bewusst nicht setzen — Browser/Axios setzen Boundary korrekt.
                const res = await axios.put(
                    API_BACKEND_URL + `update_report/${this.protokolId}`,
                    fd,
                );
                console.log(res.data);
                if (res.data[0] === 'ImgListSaved') {
                    this.applyUpdatedRecord(res.data[1], 'save');
                } else if (res.data[0] === 'ImgListUpdated') {
                    this.applyUpdatedRecord(res.data[1], 'images');
                } else if (res.data[1]) {
                    this.applyUpdatedRecord(res.data[1], 'save');
                } else {
                    this.closeModalLoader();
                }
            } catch (error) {
                const detail = messageForUploadError(error);
                const message =
                    detail ||
                    error?.response?.data?.err_message ||
                    'Etwas ist schiefgelaufen!';
                this.toast.error(message, {
                    timeout: 3000,
                });
                console.error(error);
                this.closeModalLoader();
            } finally {
                this._updateInFlight = false;
            }
        },
        onSelectChange(e) {
            this.protokolType = e.target.value;
        },
        protocolDateForInput(value) {
            if (value == null || value === '') {
                return '';
            }
            const text = String(value);
            return text.length > 16 ? text.slice(0, -3) : text;
        },
        applyServerProtocolDates(record) {
            if (!record) {
                return;
            }
            if (typeof record.dateTimeCreate === 'string' && record.dateTimeCreate) {
                this.protokolDate = this.protocolDateForInput(record.dateTimeCreate);
                const day = record.dateTimeCreate.split(/[ T]/)[0];
                if (day) {
                    this.protokolDateOnly = day;
                }
            }
            if (typeof record.dateTimeClosed === 'string') {
                this.protokolDateEnd = this.protocolDateForInput(record.dateTimeClosed);
            }
        },
        formatDateTimeDisplay(value) {
            if (!value) {
                return '';
            }
            const text = String(value).replace('T', ' ');
            return text.length > 16 ? text.slice(0, 16) : text;
        },
        handleStartDateChange(e) {
            // changes added by mg
            // send dates to report
            this.protokolDate = e.target.value;
        },
        handleEndDateChange(e) {
            // changes added by mg
            // send dates to report
            this.protokolDateEnd = e.target.value;
        },
        async deleteImage(list, index) {
            if (!this.isInBearbeitung) return;
            const imageName = list[index];
            await axios.delete(
                `${API_BACKEND_URL}delete_image_from_record/${this.protokolId}/${encodeURIComponent(imageName)}`,
            ).then(
                (res) => {
                    if (res.data == 1) {
                        this.toast.success('Das Bild wurde erfolgreich entfernt!', {
                            timeout: 2000,
                        });
                        if (this.imageBlobUrls[imageName]) {
                            URL.revokeObjectURL(this.imageBlobUrls[imageName]);
                            const next = { ...this.imageBlobUrls };
                            delete next[imageName];
                            this.imageBlobUrls = next;
                        }
                        if (this.imageCaptions[imageName] != null) {
                            const nextCaptions = { ...this.imageCaptions };
                            delete nextCaptions[imageName];
                            this.imageCaptions = nextCaptions;
                        }
                        if (index > -1) {
                            list.splice(index, 1);
                        }
                    }
                }
            )
        },
        async reloadImageBlob(img) {
            if (!img) {
                return;
            }
            if (this.imageBlobUrls[img]) {
                URL.revokeObjectURL(this.imageBlobUrls[img]);
                const next = { ...this.imageBlobUrls };
                delete next[img];
                this.imageBlobUrls = next;
            }
            if (this.imageBlobLoading) {
                delete this.imageBlobLoading[img];
            }
            await this.ensureImageBlob(img);
        },
        async rotateImage(imageName) {
            if (!this.isInBearbeitung || !imageName || this.rotatingImages[imageName]) {
                return;
            }
            this.rotatingImages = { ...this.rotatingImages, [imageName]: true };
            try {
                await axios.post(
                    `${API_BACKEND_URL}protokol/${encodeURIComponent(this.protokolId)}/images/${encodeURIComponent(imageName)}/rotate`,
                    { angle: 90 },
                );
                await this.reloadImageBlob(imageName);
            } catch (err) {
                const message =
                    err?.response?.data?.err_message ||
                    'Bild konnte nicht gedreht werden.';
                this.toast.error(message, { timeout: 2000 });
                console.error(err);
            } finally {
                const next = { ...this.rotatingImages };
                delete next[imageName];
                this.rotatingImages = next;
            }
        },
    },
    async mounted() {
        this.fetchItem(this.protokolId)
        this.containerBorder = ref('2px solid black');
        this.containerMargin = ref('8rem');
        try {
            this.$refs.displayImageWrapper.forEach((element) => {
                element.addEventListener('dragover', this.dragOver, false);
                element.addEventListener('drop', this.drop, false);
            });
        } catch (err) {
            // catched by mg
            console.log("ProtokolAnschauen.vue:578");
        }
    },
    beforeUnmount() {
        this.imageBlobUnmounted = true;
        this.abortImageBlobLoads();
        this.revokeImageBlobs();
    },

};
</script>

<style scoped>
* {
    margin: 0px;
    box-sizing: border-box;
}

.page-header .btn-action {
    flex: 1 1 0;
    min-width: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 0.35rem;
    padding: 0.55rem 0.65rem;
    font-size: 0.95rem;
    line-height: 1.25;
    min-height: 2.6rem;
    margin: 0;
    white-space: normal;
}

.page-header label.btn-action {
    margin-bottom: 0;
    cursor: pointer;
    color: #fff;
}

.file-input-hidden {
    display: none;
}

.downloadBtn .download-label {
    margin-left: 0.15rem;
}

.temptest {
    border: 2px solid black;
}

.page-header {
    --protocol-column-width: 210mm;
    margin-top: calc(var(--app-header-height) + 0.35rem);
    margin-bottom: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1.1rem;
    font-size: 2rem;
    width: 100%;
}

.page-header-top {
    width: var(--protocol-column-width);
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.35rem;
}

.page-header-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
}

.page-header h2 {
    margin: 0;
    line-height: 1.2;
    width: 100%;
    text-align: center;
}

.header-nav-link {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    color: #264271;
    font-size: 0.95rem;
    font-weight: 500;
    text-decoration: none;
    line-height: 1.2;
    padding: 0.15rem 0;
}

.header-nav-link:hover {
    color: #315492;
    text-decoration: underline;
}

.header-nav-link-right {
    margin-left: auto;
    text-align: right;
}

.nav-label-short {
    display: none;
}

#pdf-doc {
    --protocol-column-width: 210mm;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
}

#pdf-doc > div {
    width: 100%;
    max-width: var(--protocol-column-width);
    min-width: 0;
}

.btn-wrapper {
    margin: 0 auto;
    width: var(--protocol-column-width);
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: stretch;
    align-items: stretch;
    flex-wrap: nowrap;
    gap: 0.5rem;
}

.enddate-option {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    padding: 0 0.65rem;
    min-height: 2.6rem;
    color: #264271;
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
}

.enddate-option input {
    width: 1.05rem;
    height: 1.05rem;
    margin: 0;
    accent-color: #264271;
    cursor: pointer;
    border: 0;
    border-bottom: 0;
    appearance: auto;
}

.enddate-option span {
    line-height: 1.25;
}


.btn-icons {
    margin-left: 0.15rem;
}

.container {
    width: var(--protocol-column-width, 210mm);
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    height: 296mm;
    border: v-bind(containerBorder);
    /* background: url('logo.png'); */
    background: linear-gradient(to right, rgba(255, 255, 255, 0.97) 0 100%),
        url('logo_bg.png');
    background-size: 150px 150px;
    background-repeat: repeat space;
    /* background-repeat: 10%; */
    /* border: 2px solid black; */
    overflow: hidden;
    padding: 0;

    margin-left: auto;
    margin-right: auto;
    margin-bottom: v-bind(containerMargin);
    /* margin-bottom: 2rem; */
    /* margin-bottom: 12vh; */
}

.container header.protocol-meta {
    margin: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: stretch;
}

.protocol-meta > p {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    margin: 0;
    font-weight: 700;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem 0.5rem;
    box-sizing: border-box;
}

.protocol-meta > p label {
    margin-right: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.35;
}

.protocol-meta .meta-date-value {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.35;
}

/* Eingabe bleibt intern 16px (sonst Zoom beim Fokus) und wird nur optisch auf 14px verkleinert. */
.protocol-meta .meta-field {
    --meta-scale: 0.875;
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
    height: calc(1.35 * 14px);
    overflow: hidden;
    display: flex;
    align-items: center;
}

.protocol-meta .meta-field input,
.protocol-meta .meta-field select,
.protocol-meta .meta-field textarea {
    font-size: 16px;
    font-weight: 400;
    font-family: inherit;
    line-height: 1.35;
    color: inherit;
    transform: scale(var(--meta-scale));
    transform-origin: left center;
    width: calc(100% / var(--meta-scale));
    max-width: none;
    flex: none;
    height: calc(1.35 * 16px);
    margin: 0;
    padding: 0;
}

.protocol-meta input[type="datetime-local"]::-webkit-datetime-edit,
.protocol-meta input[type="datetime-local"]::-webkit-date-and-time-value {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.35;
}

@media (min-width: 901px) {
    .container header.protocol-meta {
        margin: 2rem;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
            "objekt datum"
            "typ ende";
        gap: 0.5rem 1rem;
        align-items: center;
    }

    .protocol-meta .meta-objekt { grid-area: objekt; }
    .protocol-meta .meta-datum { grid-area: datum; }
    .protocol-meta .meta-ende { grid-area: ende; }
    .protocol-meta .meta-typ { grid-area: typ; }

    .protocol-meta > p {
        width: auto;
    }
}


.grid0 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* grid-template-rows: repeat(3, 1fr); */
    /* grid-template-rows: 33% 33% 33%; */
    grid-template-rows: v-bind(gridSpilter);
    width: 100%;
    max-height: 88%;
    height: auto;
    /* place-items: center; */
    /* grid-gap: 0.5rem; */
}

.gridRest {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: repeat(3, minmax(0, 1fr));
    width: 100%;
    height: 100%;
    max-height: 100%;
    box-sizing: border-box;
}

.gridRest .imageWrapper {
    min-width: 0;
    min-height: 0;
    height: 100%;
    overflow: hidden;
}

.no-images-message {
    text-align: center;
    margin: 2rem;
}

.imageWrapper {
    position: relative;
    cursor: pointer;
    touch-action: pan-y;
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    /* max-height: 33%; */
}

.imageWrapper--loading {
    background: linear-gradient(90deg, #dce4ef 0%, #eef2f7 50%, #dce4ef 100%);
    background-size: 200% 100%;
    animation: image-placeholder-shimmer 1.1s ease-in-out infinite;
}

.imageWrapper img {
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    pointer-events: none;
}

.imageWrapper img.img-protocol {
    animation: image-fade-in 0.2s ease;
}

@keyframes image-placeholder-shimmer {
    0% {
        background-position: 100% 0;
    }

    100% {
        background-position: -100% 0;
    }
}

@keyframes image-fade-in {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.imageWrapper--readonly {
    cursor: default;
    -webkit-touch-callout: default;
}

.imageWrapper--readonly img {
    pointer-events: auto;
    -webkit-touch-callout: default;
    -webkit-user-select: auto;
    user-select: auto;
}

.imageWrapper.is-dragging {
    opacity: 0.55;
    touch-action: none;
}

.imageWrapper.drop-target {
    outline: 2px solid #264271;
    outline-offset: -2px;
}

.imageWrapper:has(.image-caption-input),
.imageWrapper:has(.image-caption-text) {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.imageWrapper:has(.image-caption-input) img.img-protocol,
.imageWrapper:has(.image-caption-text) img.img-protocol {
    flex: 1 1 auto;
    height: auto;
    min-height: 0;
    max-height: calc(100% - 3.2rem);
}

.image-caption-input {
    display: block;
    flex: 0 0 auto;
    width: calc(100% - 0.5rem);
    margin: 0.25rem 0.25rem 0.35rem;
    padding: 0.3rem 0.4rem;
    box-sizing: border-box;
    border: 1px solid #9aadc8;
    border-radius: 6px;
    font-size: 16px;
    line-height: 1.25;
    resize: none;
    min-height: 2.5rem;
    cursor: text;
    touch-action: auto;
    -webkit-user-select: text;
    user-select: text;
}

.image-caption-text {
    flex: 0 0 auto;
    margin: 0.25rem 0.35rem 0.35rem;
    padding: 0;
    font-size: 0.8rem;
    line-height: 1.25;
    color: #1c335a;
    white-space: pre-wrap;
    word-break: break-word;
}

img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* $dark: #000; */

/* .input-update { */
input,
select,
textarea {
    appearance: none;
    border: 0;
    width: 50mm;
    border-bottom: 2px solid lightblue;
    background: transparent;
    /* Mindestens 16px, sonst zoomt iOS/Android beim Fokus hinein und bleibt dort. */
    font-size: 16px;
}

.meta-date-value {
    font-weight: 400;
    min-width: 0;
    overflow-wrap: anywhere;
}

/* Editable datetime: keep value left-aligned on iOS without collapsing width. */
input[type="datetime-local"] {
    text-align: left;
    direction: ltr;
}

input[type="datetime-local"]::-webkit-date-and-time-value {
    text-align: left;
}

input:disabled,
select:disabled {
    color: inherit;
    border-bottom-color: transparent;
    cursor: default;
    opacity: 1;
    -webkit-appearance: none;
    appearance: none;
}

.display-delete-icon,
.display-rotate-icon {
    color: white;
    width: 30px;
    height: 30px;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 2;
    /* border: 2px solid rgb(103, 103, 103); */
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(38, 66, 113, 0.9);
    font-size: 0.9rem;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
}

.display-rotate-icon {
    right: auto;
    left: 0.5rem;
}

.imageWrapper--rotating img {
    opacity: 0.45;
}

input:focus,
select:focus {
    outline: none;
}



@media (max-width: 900px) {

    .page-header {
        padding: 0 0.75rem;
        box-sizing: border-box;
        margin-top: calc(var(--app-header-height) + 0.25rem);
        margin-bottom: 0.5rem;
        gap: 0.9rem;
    }

    .page-header-top {
        width: 100%;
    }

    .header-nav-link {
        font-size: 0.9rem;
    }

    .nav-label-full {
        display: none;
    }

    .nav-label-short {
        display: inline;
    }

    .page-header .btn-action {
        flex: 1 1 calc(50% - 0.5rem);
        font-size: 0.8rem;
        padding: 0.45rem 0.55rem;
        min-height: 2.35rem;
    }

    .btn-wrapper {
        flex-wrap: wrap;
        width: 100%;
        max-width: 100%;
        padding: 0;
        box-sizing: border-box;
    }

    .enddate-option {
        flex: 1 1 100%;
        justify-content: flex-start;
        white-space: normal;
        font-size: 0.85rem;
        min-height: 2.35rem;
        padding: 0.25rem 0;
    }

    #pdf-doc {
        padding: 0 0.75rem calc(var(--app-footer-height) + 1.5rem);
        box-sizing: border-box;
    }

    #pdf-doc > div {
        max-width: 100%;
    }

    .container {
        width: 100%;
        max-width: 100%;
        height: auto;
        min-height: 70vh;
        overflow: visible;
        margin-bottom: 1.5rem;
    }

    /* Folgeseiten (9 Bilder): Kasten + Raster füllen die Viewport-Höhe */
    .container:has(.gridRest) {
        display: flex;
        flex-direction: column;
        min-height: calc(100dvh - var(--app-header-height) - var(--app-footer-height) - 7rem);
    }

    .container header.protocol-meta {
        margin: 0.75rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        align-items: stretch;
    }

    .protocol-meta .meta-objekt,
    .protocol-meta .meta-datum,
    .protocol-meta .meta-ende,
    .protocol-meta .meta-typ {
        grid-area: unset;
    }

    .protocol-meta .meta-objekt { order: 1; }
    .protocol-meta .meta-datum { order: 2; }
    .protocol-meta .meta-ende { order: 3; }
    .protocol-meta .meta-typ { order: 4; }

    .protocol-meta > p {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    .imageWrapper > .display-delete-icon,
    .imageWrapper > .display-rotate-icon {
        width: 28px;
        height: 28px;
        min-width: 28px;
        max-width: 28px;
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: nowrap;
        gap: 0;
        font-size: 0.75rem;
        top: 0.35rem;
        position: absolute;
    }

    .imageWrapper > .display-delete-icon {
        right: 0.35rem;
    }

    .imageWrapper > .display-rotate-icon {
        right: auto;
        left: 0.35rem;
    }

    .protocol-meta label {
        flex: 0 0 auto;
        margin-right: 0;
        font-size: 14px;
    }

    .protocol-meta .meta-field {
        flex: 1 1 8rem;
        min-width: 0;
        max-width: 100%;
    }

    .protocol-meta .meta-date-value {
        flex: 1 1 auto;
        font-size: 14px;
    }

    .protocol-meta select {
        max-width: none;
    }

    .grid0,
    .gridRest {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        padding: 0;
        height: auto;
        max-height: none;
        gap: 0;
    }

    .grid0 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-template-rows: none;
    }

    .gridRest {
        flex: 1 1 auto;
        min-height: 0;
        height: 100%;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        grid-template-rows: repeat(3, minmax(0, 1fr));
    }

    .imageWrapper {
        min-width: 0;
        overflow: hidden;
        aspect-ratio: 1 / 1;
        user-select: none;
    }

    .gridRest .imageWrapper {
        aspect-ratio: auto;
        height: 100%;
        min-height: 0;
    }

    .imageWrapper img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}
</style>
